import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import Store from 'store/store';
// import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {

	closeAndNavigate(id, e, linkName, queryString) {
		const sounds = {
			boltHome: 'mario-pipe',
			boltShowtimes: 'mario-punch',
			boltVideos: 'mario-training',
			boltSynopsis: 'mario-smash',
			boltExpandableTextPage: 'mario-shrink'
		};
		Store.emit('PLAY_SOUND', sounds[id] || 'mario-pipe');
		return super.closeAndNavigate(id, e, linkName, queryString);
	}

}
